import type { FaireProductEntity } from "../../entity_types/product";

export const faire_nudge_8: FaireProductEntity = {
  token: "faire_nudge_8",
  type: "product",
  name: "Pine Candle",
  brandName: "Candle Brand",
  imageUrl:
    "https://images.unsplash.com/photo-1605651202774-7d573fd3f12d?w=100&h=100&fit=crop",
  priceDollars: 18,
  msrpDollars: 36,
  description: "Migrated candle ops mock product",
  tags: ["candle", "ops"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
